// src/Resources/app/administration/src/sw-admin-menu/index.js
import template from './sw-admin-menu.html.twig';

Shopware.Component.override('sw-admin-menu', {
    template,

    computed: {
        shopUrl() {
            // Returns the base URL of the shop, e.g., "https://my-shop.com"
            return window.location.origin;
        }
    }
});